import { render } from "./GecceleDirect.vue?vue&type=template&id=151a6aa0&scoped=true"
const script = {}

import "./GecceleDirect.vue?vue&type=style&index=0&id=151a6aa0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151a6aa0"]])

export default __exports__